/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-2",
    "aws_cloud_logic_custom": [
        {
            "name": "api94d03d7c",
            "endpoint": "https://iz49n0aiq9.execute-api.us-west-2.amazonaws.com/prod",
            "region": "us-west-2"
        }
    ]
};


export default awsmobile;
